import { render } from "./HealthAnalysis.vue?vue&type=template&id=fb8cea08&scoped=true"
import script from "./HealthAnalysis.vue?vue&type=script&lang=js"
export * from "./HealthAnalysis.vue?vue&type=script&lang=js"

import "./HealthAnalysis.vue?vue&type=style&index=0&id=fb8cea08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb8cea08"]])

export default __exports__